'use client'

import React, { useState } from 'react'
import { IconButton, styled } from '@mui/material'
import PropTypes from 'prop-types'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

const ControlsContainer = styled('div')(({ theme, bgColor }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 10,
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  backgroundColor: bgColor,
  padding: '0 8px',
  maxWidth: '100%',
  boxSizing: 'border-box',
  [theme.breakpoints.up('lg')]: {
    padding: '0 16px',
  },
}))

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  '&:hover': {
    opacity: 0.8,
    backgroundColor: 'transparent',
  },
}))

const CloseButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M18.9999 6.41L17.5899 5L11.9999 10.59L6.40988 5L4.99988 6.41L10.5899 12L4.99988 17.59L6.40988 19L11.9999 13.41L17.5899 19L18.9999 17.59L13.4099 12L18.9999 6.41Z"
      fill="white"
    />
  </svg>
)

const PlayButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M9.99988 0C4.47988 0 -0.00012207 4.48 -0.00012207 10C-0.00012207 15.52 4.47988 20 9.99988 20C15.5199 20 19.9999 15.52 19.9999 10C19.9999 4.48 15.5199 0 9.99988 0ZM9.99988 18C5.58988 18 1.99988 14.41 1.99988 10C1.99988 5.59 5.58988 2 9.99988 2C14.4099 2 17.9999 5.59 17.9999 10C17.9999 14.41 14.4099 18 9.99988 18ZM7.49988 14.5L14.4999 10L7.49988 5.5V14.5Z"
      fill="white"
    />
  </svg>
)

const PauseButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M6.99988 14H8.99988V6H6.99988V14ZM9.99988 0C4.47988 0 -0.00012207 4.48 -0.00012207 10C-0.00012207 15.52 4.47988 20 9.99988 20C15.5199 20 19.9999 15.52 19.9999 10C19.9999 4.48 15.5199 0 9.99988 0ZM9.99988 18C5.58988 18 1.99988 14.41 1.99988 10C1.99988 5.59 5.58988 2 9.99988 2C14.4099 2 17.9999 5.59 17.9999 10C17.9999 14.41 14.4099 18 9.99988 18ZM10.9999 14H12.9999V6H10.9999V14Z"
      fill="white"
    />
  </svg>
)

const cookieOptions = { secure: true, maxAge: 2592000, httpOnly: false, path: '/', sameSite: 'lax' }

const TopBarInfoControls = ({ swiper, setIsClosed, bgColor }) => {
  const [isAutoplayPaused, setIsAutoplayPaused] = useState(false)

  const handlePausePlayClick = e => {
    e.stopPropagation()
    if (isAutoplayPaused) {
      setIsAutoplayPaused(false)
      swiper?.autoplay?.start()
    } else {
      setIsAutoplayPaused(true)
      swiper?.autoplay?.stop()
    }
  }

  const handleCloseClick = () => {
    setIsClosed(true)
    cookies.set('__Host-rtg_top_info_banner', true, cookieOptions)
  }

  return (
    <ControlsContainer bgColor={bgColor}>
      <StyledIconButton onClick={handlePausePlayClick} variant="text" aria-describedby="autoplay-button-description">
        {isAutoplayPaused ? <PlayButton /> : <PauseButton />}
      </StyledIconButton>
      <StyledIconButton onClick={handleCloseClick} variant="text" aria-label="Close banner slider">
        <CloseButton />
      </StyledIconButton>
      <div id="autoplay-button-description" role="status" aria-live="polite" className="hide508">
        {isAutoplayPaused ? 'Play banner slider' : 'Pause banner slider'}
      </div>
    </ControlsContainer>
  )
}

TopBarInfoControls.propTypes = {
  swiper: PropTypes.shape({
    autoplay: PropTypes.shape({
      start: PropTypes.func,
      stop: PropTypes.func,
    }),
  }),
  setIsClosed: PropTypes.func.isRequired,
  bgColor: PropTypes.string.isRequired,
}

export default TopBarInfoControls
